import { Injectable } from '@angular/core';
import { EventEmitter } from '@angular/core';

@Injectable()
export class SharedEventService {
  showFbMessengerEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
}

